import QuizMcqSection from "./QuizMcqSection";

export default QuizMcqSection;
